import { useLocation } from "react-router-dom";
import QueryString from "../helpers/querystring";

const useQueryString = () => {
    const location = useLocation();
    return new QueryString(location.search || "?");
};

export default useQueryString;